import Vue from 'vue';
import VueSimpleSpinner from 'vue-simple-spinner';
import {Task as TaskModel, UpdateFields} from '@/interfaces/TaskInterfaces';
import {updateTask} from "@/services/TaskService";

export default Vue.component('task-modal', {
  name: 'TaskModal',
  props: {
    taskId: { type: Number, required: true }
  },
  components: {
    VueSimpleSpinner
  },
  data() {
    return {
      timeout: 0 as number,
      showDetails: false
    }
  },
  computed: {
    task(): TaskModel | undefined {
      const task = this.$store.state.task.individualTasks.find((task: TaskModel) => task.id === this.taskId);
      if (task) {
        if (this.timeout) {
          window.clearTimeout(this.timeout);
        }
        task.showDetails = this.showDetails;
        if (!task.isRead && task.assignedToAppUserId === this.$store.state.user.appUserId) {
          updateTask(task.id, UpdateFields.IS_READ, {newValue: true})
            .catch(() => {
              (this as any).$notify({
                group: 'main',
                type: 'error',
                title: 'Error',
                text: 'Failed to mark Task read.'
              });
            });
        }
      }
      return task;
    }
  },
  created() {
    this.$store.commit('task/addIndividualId', this.taskId);
    this.timeout = window.setTimeout(() => {
      (this as any).$notify({
        group: 'main',
        type: 'error',
        title: 'Error',
        text: 'Failed to load Task.'
      });
      (this as any).cancel();
    }, 3000);
  },
  mounted() {
    document.addEventListener('keyup', this.escapeListener);
  },
  beforeDestroy() {
    this.$store.commit('task/removeIndividualId', this.taskId);
    document.removeEventListener('keyup', this.escapeListener);
  },
  methods: {
    escapeListener(evt: any) {
      if (evt.key === 'Escape') {
        this.cancel();
      }
    },
    cancel() {
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.$emit('cancel-event');
    },
    storeShowDetailsState(task: TaskModel) {
      this.showDetails = task.showDetails;
    }
  }
});



// WEBPACK FOOTER //
// ./src/componentsReusable/tasks/modal/TaskModal.ts